import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getArea = (networkDeviceId) => {
    return axios.get(`/api/DaliEsSystemArea/getlist/${networkDeviceId}`, { headers: authHeader() })
        .then(res => {return res.data});
};

const getAreaById = (areaId) => {
    return axios.get(`/api/DaliEsSystemArea/getById/${areaId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const createArea = (areaModel) => {
    delete areaModel['id'];
    return axios.post(`/api/DaliEsSystemArea/`, areaModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const editArea = (areaModel) => {
    return axios.patch(`/api/DaliEsSystemArea/${areaModel.id}`, areaModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteArea = (areaId) => {
    return axios.delete(`/api/DaliEsSystemArea/${areaId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const getGroups = (networkDeviceId) => {
    return axios.get(`/api/DaliEsSystemGroups/getlist/${networkDeviceId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const createGroup = (groupModel) => {
    delete groupModel['id'];
    return axios.post(`/api/DaliEsSystemGroups/`, groupModel, { headers: authHeader() })
        .then(res => { return res.data });
};

const editGroup = (groupModel) => {
    return axios.patch(`/api/DaliEsSystemGroups/${groupModel.id}`, groupModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteGroup = (groupId) => {
    return axios.delete(`/api/DaliEsSystemGroups/${groupId}`, { headers: authHeader() })
        .then(res=> { return res.data })
};

const getGroupById = (helvarGroupId) => {
    return axios.get(`/api/DaliEsSystemGroups/GetById/${helvarGroupId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const getScenes = (helvarGroupId) => {
    return axios.get(`/api/DaliEsSystemScenes/getlist/${helvarGroupId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const createScene = (sceneModel) => {
    delete sceneModel["id"];
    return axios.post(`/api/DaliEsSystemScenes`, sceneModel, { headers: authHeader() } )
        .then(res => { return res.data })
};

const editScene = (sceneModel) => {
    return axios.patch(`/api/DaliEsSystemScenes/${sceneModel.id}`, sceneModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const deleteScene = (sceneId) => {
    return axios.delete(`/api/DaliEsSystemScenes/${sceneId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const getGroupsFromDevice = (deviceId) => {
    return axios.get(`/api/DaliEsSystemGroups/GetGroupsFromDevice/${deviceId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

export const daliEsSystemService = {
    // lists
    getArea,
    getAreaById,
    getGroups,
    getGroupById,
    getScenes,
    getGroupsFromDevice,
    // creates
    createArea,
    createGroup,
    createScene,
    // updates
    editArea,
    editGroup,
    editScene,
    // delete
    deleteArea,
    deleteGroup,
    deleteScene,
};
